export default "__VITE_ASSET__BCo3ot2R__"